import { render, staticRenderFns } from "./RemoveTag.vue?vue&type=template&id=033c6e1a"
import script from "./RemoveTag.vue?vue&type=script&lang=js"
export * from "./RemoveTag.vue?vue&type=script&lang=js"
import style0 from "./RemoveTag.vue?vue&type=style&index=0&id=033c6e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports